// Typelizer digest 33b67a63beb9a8377fa47e6922f273a4
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /session/signed_out */
  signedOut: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/session/signed_out', {}, options),
    method: 'get',
  }),

  /** GET /session/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/session/new', {}, options),
    method: 'get',
  }),

  /** DELETE /session */
  destroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/session', {}, options),
    method: 'delete',
  }),

  /** POST /session */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/session', {}, options),
    method: 'post',
  }),
}
